export const getStyles = (theme) => {
  return {
    mainContainer : {
      display        : 'flex',
      justifyContent : 'center',
      maxWidth       : '522px',
      width          : '100%',
      margin         : 'auto',
      marginTop      : '27px',
    },
    stack : { maxWidth: '522px', padding: '0px 10px 0px 10px' },
    icon  : {
      width  : '21px',
      height : '21px',
    },
    title : {
      color      : theme.palette.primary.gray8,
      fontFamily : 'Montserrat',
      fontStyle  : 'normal',
      fontWeight : 700,
      fontSize   : '16px',
      lineHeight : '24px',
    },
    text : {
      color      : theme.palette.primary.gray6,
      fontFamily : 'Montserrat',
      fontStyle  : 'normal',
      fontWeight : 400,
      fontSize   : '16px',
      lineHeight : '24px',
      marginTop  : '16px',
    },
    btnContainer : {
      display        : 'flex',
      justifyContent : 'center',
      margin         : '50px 0',
    },
    img : { borderRadius: '10px', width: '100%' },
  };
};
